var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFoodStorage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 17,
  viewBox: "0 0 22 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.67 8V6.67h4.66V8zM1.67 13.33H3v3.34H1.67zM19 13.33h1.33v3.34H19zM8.33 6.67V8H3.67V6.67z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.67 1.33v12h18.66v-12zm20-1.33v14.67H.33V0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.33 0h1.34v14.67h-1.34z"
})));
export default SvgFoodStorage;